(function () {
    'use strict';

    angular
        .module('observationEditModule')
        .controller('ObservationRecommendationAddController', Controller);

    Controller.$inject = ['$scope', '$state', '$stateParams', 'grcObservationService', 'auditMandateService', 'historyCtxtService', 'observation', 'controls'];

    function Controller($scope, $state, $stateParams, grcObservationService, auditMandateService, historyCtxtService, observation, controlTest, campaign, businessUnit, controls) {

        $scope.observation = observation;
        $scope.controls = controls;
        $scope.recommendation = {};
    }
})();